class ProductTabs {
    constructor(container) {
        this.container = container;
        this.tabs = Array.from(container.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(container.querySelectorAll('[role="tabpanel"]'));
        this.bindEvents();
    }

    bindEvents() {
        this.tabs.forEach((tab) => {
            tab.addEventListener('click', () => this.activateTab(tab));
            tab.addEventListener('keydown', (event) => this.handleKeydown(event, tab));
        });
    }

    handleKeydown(event, tab) {
        const key = event.key;
        const currentIndex = this.tabs.indexOf(tab);
        let nextIndex = null;

        if (key === 'ArrowRight') {
            nextIndex = (currentIndex + 1) % this.tabs.length;
        } else if (key === 'ArrowLeft') {
            nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        } else if (key === 'Home') {
            nextIndex = 0;
        } else if (key === 'End') {
            nextIndex = this.tabs.length - 1;
        }

        if (nextIndex !== null) {
            event.preventDefault();
            this.activateTab(this.tabs[nextIndex]);
            this.tabs[nextIndex].focus();
        }
    }

    activateTab(tab) {
        const targetId = tab.getAttribute('aria-controls');

        this.tabs.forEach((item) => {
            const isActive = item === tab;
            item.setAttribute('aria-selected', isActive ? 'true' : 'false');
            item.tabIndex = isActive ? 0 : -1;
        });

        this.panels.forEach((panel) => {
            const isActive = panel.id === targetId;
            if (isActive) {
                panel.removeAttribute('hidden');
            } else {
                panel.setAttribute('hidden', '');
            }
            panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });
    }
}

const initProductTabs = () => {
    document.querySelectorAll('[data-product-tabs]').forEach((container) => {
        new ProductTabs(container);
    });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductTabs);
} else {
    initProductTabs();
}
